<template>
	<section class="container" v-if="product">

		<header class="container__header">

			<section class="settings">

				<h1 v-text="product.title"></h1>

				<ws-dropdown>

					<template slot="thumb">	<i class="fas fa-cog icon--sm dark-grey"></i></template>

					<template slot="content">

						<ul>
							<li><a href="#" @click.prevent="" v-clipboard:copy="product.url"><i class="fas fa-clipboard"></i> Kopier link</a></li>
                            <li><a href="#" @click.prevent="showExportDatePickerModal = true"><i class="fas fa-file-alt"></i> Hent salgstal</a></li>
                            <li><a href="#" @click.prevent="showLabelsDatePickerModal = true"><i class="fas fa-sticky-note"></i> Hent pakkelabels</a></li>
							<li><router-link :to="{name:'product.edit', params:{product:product.id}}"><i class="fas fa-pencil-alt"></i> Rediger</router-link></li>
							<li><router-link :to="{name:'product.status', params:{product:product.id}}"><i class="fas fa-ban"></i> Inaktive datoer</router-link></li>
							<li><a href="#" @click.prevent="showDeleteModal = true"><i class="fas fa-trash-alt"></i> Slet</a></li>

							<li>
								<a href="#" :class="{'disabled':!product.active}"  @click.prevent="doShowActivationModal" :disabled="!product.active">
									<template v-if="!product.active"><i class="fas fa-eye"></i> Aktiver</template>
									<template v-else><i class="fas fa-eye-slash"></i> Deaktiver</template>
								</a>
							</li>
						</ul>

					</template>

				</ws-dropdown>

			</section>

			<h3 v-if="product.active">Status: Aktiv</h3>
			<h3 v-else>Status: Inaktiv</h3>

		</header>

		<section class="container__body container__body--lg">

			<header class="col-12 margin-b-50 flex--space">

				<h1>Statistik</h1>

				<section class="datepicker">

					<a href="#" @click.prevent="showDatePickerModal = true"><i class="icon--md fas fa-calendar-alt"></i> {{dateRangeText}}</a>

				</section>

			</header>

			<main class="stats">

				<section class="item">

					<h1>
						<animate-number
								:from="old_total_revenue"
								:to="stripeAmount(stats.total_revenue).amountForEditing"
								duration="2000"
								easing="easeInOutCirc"
								mode="manual"
								ref="totalRevenue">
						</animate-number><span>kr</span>
					</h1>

					<h2>Total omsætning</h2>

					<p>Den totale omsætning i den </br> valgte tidsperiode med tilkøb.</p>

				</section>

				<section class="item">

					<h1>
						<animate-number
								:from="old_average_revenue"
								:to="stripeAmount(stats.average_revenue).amountForEditing"
								duration="2000"
								easing="easeInOutCirc"
								mode="manual"
								ref="averageRevenue">
						</animate-number><span>kr</span></h1>

					<h2>Gns. omsætning pr. ordre</h2>

					<p>Den gns. omsætning i den </br> valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1>
						<animate-number
								:from="old_total_revenue_count"
								:to="stats.total_revenue_count"
								duration="2000"
								easing="easeInOutCirc"
								mode="manual"
								ref="totalCount">
						</animate-number><span>stk</span></h1>

					<h2>Antal solgte</h2>

					<p>Det totale antal solgte kuverter </br> i den valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1>
						<animate-number
								:from="old_total_number_of_orders"
								:to="stats.total_number_of_orders"
								duration="2000"
								easing="easeInOutCirc"
								mode="manual"
								ref="totalNumberOfOrders">
						</animate-number><span>stk</span></h1>

					<h2>Antal ordre</h2>

					<p>Det totale antal ordre </br> i den valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1>
						<animate-number
								:from="old_total_revenue_without_extra"
								:to="stripeAmount(stats.total_revenue_without_extra).amountForEditing"
								duration="2000"
								easing="easeInOutCirc"
								mode="manual"
								ref="totalRevenueWithoutExtra"
						></animate-number><span>kr</span>
					</h1>

					<h2>Total omsætning uden tilkøb</h2>

					<p>Den totale omsætning uden tilkøb </br> i den valgte tidsperiode.</p>

				</section>

				<section class="item">

					<h1>
						<animate-number
								:from="old_total_extra_revenue"
								:to="stripeAmount(stats.total_extra_revenue).amountForEditing"
								duration="2000"
								easing="easeInOutCirc"
								mode="manual"
								ref="totalExtraRevenue"
						></animate-number><span>kr</span>
					</h1>

					<h2>Total omsætning for tilkøb</h2>

					<p>Den totale omsætning for tilkøb </br> i den valgte tidsperiode.</p>

				</section>

                <section class="item">

                    <h1>
                        <animate-number
                            :from="old_total_premium_revenue"
                            :to="stripeAmount(stats.total_premium_revenue).amountForEditing"
                            duration="2000"
                            easing="easeInOutCirc"
                            mode="manual"
                            ref="totalPremiumRevenue"
                        ></animate-number><span>kr</span>
                    </h1>

                    <h2>Total omsætning for premium</h2>

                    <p>Den totale omsætning for premium </br> i den valgte tidsperiode.</p>

                </section>


			</main>

		</section>

		<ws-modal v-model="showDeleteModal">

			<section class="modal-wrap">

				<section class="modal--sm center">

					<span class="close" @click.prevent="showDeleteModal = false"><i class="fas fa-times"></i></span>

					<i class="fas fa-trash-alt icon--lg margin-b-25"></i>

					<h1>Slet Produkt</h1>

					<h2>Er du sikker på du vil slette {{product.title}}?</h2>

					<h3>Du kan ikke fortryde denne handling!</h3>

					<section class="col-12 margin-t-25">

						<a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="deleteProduct">Ja tak</a>

						<a href="#" @click.prevent="showDeleteModal = false">Nej tak!</a>

					</section>

				</section>

			</section>

		</ws-modal>

		<ws-modal v-model="showDatePickerModal">

			<section class="modal-wrap">

				<section class="modal--sm center">

					<span class="close" @click.prevent="datePickerReset"><i class="fas fa-times"></i></span>

					<section class="datepicker-trigger" id="datepicker-trigger">
						<AirbnbStyleDatepicker
								:trigger-element-id="'datepicker-trigger'"
								:inline="true"
								:mode="'range'"
								:date-one="dateStartForDatePicker"
								:date-two="dateEndForDatePicker"
								:showActionButtons="false"
								:monthsToShow="1"
								@date-one-selected="setStartDate"
								@date-two-selected="setEndDate"
						/>
					</section>

				</section>

			</section>

		</ws-modal>

        <ws-modal v-model="showExportDatePickerModal">

            <section class="modal-wrap">

                <section class="modal--sm center">

                    <span class="close" @click.prevent="showExportDatePickerModal = false"><i class="fas fa-times"></i></span>

                    <section class="datepicker-trigger" id="product-export-datepicker-trigger">
                        <AirbnbStyleDatepicker
                            :trigger-element-id="'product-export-datepicker-trigger'"
                            :inline="true"
                            :mode="'range'"
                            :date-one="dateStartForExportDatePicker"
                            :date-two="dateEndForExportDatePicker"
                            :showActionButtons="false"
                            :monthsToShow="1"
                            @date-one-selected="setExportStartDate"
                            @date-two-selected="setExportEndDate"
                        />
                    </section>

                </section>

            </section>

        </ws-modal>

        <ws-modal v-model="showLabelsDatePickerModal">

            <section class="modal-wrap">

                <section class="modal--sm center">

                    <span class="close" @click.prevent="understood"><i class="fas fa-times"></i></span>

                    <transition name="fade" mode="out-in">

                        <section class="datepicker-trigger" id="product-labels-datepicker-trigger" v-if="!showQueuedMessage">
                            <AirbnbStyleDatepicker
                                :trigger-element-id="'product-labels-datepicker-trigger'"
                                :inline="true"
                                :mode="'range'"
                                :date-one="dateStartForLabelsDatePicker"
                                :date-two="dateEndForLabelsDatePicker"
                                :showActionButtons="false"
                                :monthsToShow="1"
                                @date-one-selected="setLabelsStartDate"
                                @date-two-selected="setLabelsEndDate"
                            />
                        </section>

                        <section v-else>
                            <h4>Vi er gået i gang med at skabe pakkelabels for produktet.</h4>
                            <h4>Du vil, om et øjeblik, modtage en mail når de er klar</h4>
                            <h4 class="margin-t-25">I mellemtiden kan du fortsætte med at benytte systemet.</h4>

                            <a href="#" class="btn btn--primary btn--sm primary--copper margin-t-50" @click="understood">Fortsæt</a>
                        </section>

                    </transition>


                </section>

            </section>

        </ws-modal>

		<ws-modal v-model="showActivationModal">

			<section class="modal-wrap">

				<section class="modal--sm center">

					<span class="close" @click.prevent="showActivationModal = false"><i class="fas fa-times"></i></span>

					<i class="fas fa-trash-alt icon--lg margin-b-25"></i>

					<h1 v-if="!product.active">Aktiver Produkt</h1>
					<h1 v-else>Deaktiver Produkt</h1>

					<h2 v-if="!product.active">Er du sikker på du vil aktivere {{product.title}}?</h2>
					<h2 v-else>Er du sikker på du vil deaktivere {{product.title}}?</h2>

					<section class="col-12 margin-t-25">

						<a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="productActivation">Ja tak</a>

						<a href="#" @click.prevent="showActivationModal = false">Nej tak!</a>

					</section>

				</section>

			</section>

		</ws-modal>

	</section>
</template>

<script>
    import {format} from 'date-fns';
    import da from 'date-fns/locale/da';
    import moment from "moment/moment";
    export default {
        name: "product-stats",
		data(){
            return {
                product:null,
                stats:{
                    total_revenue:0,
                    average_revenue:0,
                    total_revenue_without_extra:0,
                    total_extra_revenue:0,
                    total_premium_revenue:0,
                    total_revenue_count:0,
                    total_number_of_orders:0,
                },
                showDeleteModal:false,
                showDatePickerModal:false,
                showExportDatePickerModal:false,
                showLabelsDatePickerModal:false,
                showActivationModal:false,
                dateStartForDatePicker:'',
                dateEndForDatePicker:'',
                dateStart:'',
                dateEnd:'',
				old_total_revenue:0,
				old_average_revenue:0,
				old_total_revenue_count:0,
                old_total_revenue_without_extra:0,
                old_total_extra_revenue:0,
                old_total_premium_revenue:0,
                old_total_number_of_orders:0,
				format,
                dateStartForExportDatePicker:'',
                dateEndForExportDatePicker:'',
                dateStartForLabelsDatePicker:'',
                dateEndForLabelsDatePicker:'',
                showQueuedMessage: false,
			};
		},
		computed:{
            dateRangeText(){
                if(this.dateStart === '' && this.dateEnd === ''){
                    return 'Vælg datoer'
                }
                let startDate = this.format(this.dateStart, 'MMMM DD, YYYY', {locale:da});
                let endDate = this.format(this.dateEnd, 'MMMM DD, YYYY', {locale:da})
                return startDate.charAt(0).toUpperCase() + startDate.slice(1) + ' - ' + endDate.charAt(0).toUpperCase() + endDate.slice(1);
            },
            exportUrl(){
                return `/admin/product/${this.product.id}/stats/export?startDate=${this.dateStartForExportDatePicker}&endDate=${this.dateEndForExportDatePicker}`;
            }
		},
		methods:{
			getProduct(){
                axios.get(`/api/admin/product/${this.$route.params.product}/stats`).then(response => {
                    this.product = response.data.data.product;
                    this.stats = response.data.data.stats;
                    setTimeout(()=>{
                        this.$refs.totalCount.start();
                        this.$refs.totalRevenue.start();
                        this.$refs.totalRevenueWithoutExtra.start();
                        this.$refs.totalExtraRevenue.start();
                        this.$refs.totalPremiumRevenue.start();
                        this.$refs.averageRevenue.start();
                        this.$refs.totalNumberOfOrders.start();
                    }, 500);
                });
			},
            getProductStatsByRange(){
                axios.post(`/api/admin/product/${this.$route.params.product}/stats`,{
                    start: this.dateStart,
                    end: this.dateEnd,
                }).then(response => {
                    this.old_total_revenue = this.stats.total_revenue;
                    this.old_average_revenue = this.stats.average_revenue;
                    this.old_total_revenue_without_extra = this.stats.total_revenue_without_extra;
                    this.old_total_extra_revenue = this.stats.total_extra_revenue;
                    this.old_total_premium_revenue = this.stats.total_premium_revenue;
                    this.old_total_revenue_count = this.stats.total_revenue_count;
                    this.old_total_number_of_orders = this.stats.total_number_of_orders;

                    this.product = response.data.data.product;
                    this.stats = response.data.data.stats;

                    setTimeout(()=>{
                        this.$refs.totalCount.reset(this.old_total_revenue_count, this.stats.total_revenue_count);
                        this.$refs.totalRevenue.reset(this.stripeAmount(this.old_total_revenue).amountForEditing, this.stripeAmount(this.stats.total_revenue).amountForEditing);
                        this.$refs.totalRevenueWithoutExtra.reset(this.stripeAmount(this.old_total_revenue_without_extra).amountForEditing, this.stripeAmount(this.stats.total_revenue_without_extra).amountForEditing);
                        this.$refs.totalExtraRevenue.reset(this.stripeAmount(this.old_total_extra_revenue).amountForEditing, this.stripeAmount(this.stats.total_extra_revenue).amountForEditing);
                        this.$refs.totalPremiumRevenue.reset(this.stripeAmount(this.old_total_premium_revenue).amountForEditing, this.stripeAmount(this.stats.total_premium_revenue).amountForEditing);
                        this.$refs.averageRevenue.reset(this.stripeAmount(this.old_average_revenue).amountForEditing, this.stripeAmount(this.stats.average_revenue).amountForEditing);
                        this.$refs.totalNumberOfOrders.reset(this.old_total_number_of_orders, this.stats.total_number_of_orders);

                        this.$refs.totalCount.start();
                        this.$refs.totalRevenue.start();
                        this.$refs.totalRevenueWithoutExtra.start();
                        this.$refs.totalExtraRevenue.start();
                        this.$refs.totalPremiumRevenue.start();
                        this.$refs.averageRevenue.start();
                        this.$refs.totalNumberOfOrders.start();
                    }, 500);
                });
            },
            revenueFormatter(num){
			    num = this.stripeAmount(num).amount;
                return num > 999 ? (num/1000).toFixed(1): num.toFixed(1);
            },
            deleteProduct(){
                axios.delete(`/api/admin/product/${this.$route.params.product}`).then(()=>{
                    this.$router.replace({
                        name:'product.index',
                    })
                });
            },
			setStartDate(val){
                this.dateStartForDatePicker = val;
            },
            setEndDate(val){
                this.dateStart = this.dateStartForDatePicker;
                this.dateEnd = val;
                this.getProductStatsByRange();
                this.datePickerReset()
            },
            datePickerReset(){
                this.showDatePickerModal = false;
                this.dateStartForDatePicker = '';
                this.dateEndForDatePicker = '';
            },
			productActivation(){
			    if(!this.product.active){
					axios.put(`/api/admin/product/${this.product.id}/activate`).then(response=>{
					    this.showActivationModal = false;
                        this.getProduct();
					});
				}else{
                    axios.put(`/api/admin/product/${this.product.id}/deactivate`).then(response=>{
                        this.showActivationModal = false;
                        this.getProduct();
                    });
				}

			},
			doShowActivationModal(){
			    if(!this.product.active){
			        return;
				}
				this.showActivationModal = true;
			},
            setExportStartDate(val){
                this.dateStartForExportDatePicker = val;
            },
            setExportEndDate(val){
                this.dateEndForExportDatePicker = val;
                this.showExportDatePickerModal = false;

                window.location = this.exportUrl;

                this.dateStartForExportDatePicker = '';
                this.dateEndForExportDatePicker = '';
            },
            setLabelsStartDate(val){
                this.dateStartForLabelsDatePicker = val;
            },
            setLabelsEndDate(val){
                this.dateEndForLabelsDatePicker = val;
                this.showExportDatePickerModal = false;

                this.showQueuedMessage = true;

                axios.post(`/api/admin/product/${this.product.id}/stats/printlabels`, {
                    'start_date': this.dateStartForLabelsDatePicker,
                    'end_date': this.dateEndForLabelsDatePicker,
                }).then(response => {
                    this.dateStartForLabelsDatePicker = '';
                    this.dateEndForLabelsDatePicker = '';
                });

                //window.location = `/admin/custom/product/${this.product.id}/stats/printlabelsRegularView`;
            },
            understood(){
                this.showLabelsDatePickerModal = false;
                this.dateStartForLabelsDatePicker = '';
                this.dateEndForLabelsDatePicker = '';
                setTimeout(()=>{
                    this.showQueuedMessage = false
                }, 200);
            }
		},
        created(){
            this.dateStart = moment().startOf('month').format('YYYY-MM-DD');
            this.dateEnd = moment().endOf('month').format('YYYY-MM-DD');
            this.getProductStatsByRange();
        }
    }
</script>

<style scoped>

</style>
